import { CartList } from "../components";

const CartPage = () => {
  return (
    <div>
      <header>Car List</header>
      <CartList />
    </div>
  );
};

export default CartPage;
